export const statisticsOrderStepValidationMap = {
  0: {
    fieldNames: [
      'StatisticsOrder.Title',
      'StatisticsOrder.IsUpdateOfPriorOrder',
      'StatisticsOrder.PriorOrderReference',
      'StatisticsOrder.FrequencyOfDeliveries',
      'StatisticsOrder.AdditionalInformation',
      'StatisticsOrder.Registers',
      'StatisticsOrder.Constraints',
      'StatisticsOrder.Presentation'
    ],
    stepId: 0
  },
  1: {
    fieldNames: [
      'StatisticsOrder.ContactPerson.Name',
      'StatisticsOrder.ContactPerson.Organisation',
      'StatisticsOrder.ContactPerson.Email',
      'StatisticsOrder.ContactPerson.CountryCode',
      'StatisticsOrder.ContactPerson.Phone',
      'StatisticsOrder.BillingDetails.Organisation',
      'StatisticsOrder.BillingDetails.OrganisationNumber',
      'StatisticsOrder.BillingDetails.BillingReference',
      'StatisticsOrder.BillingDetails.BillingAddress.StreetAddress',
      'StatisticsOrder.BillingDetails.BillingAddress.ZipCode',
      'StatisticsOrder.BillingDetails.BillingAddress.City',
      'StatisticsOrder.BillingDetails.BillingAddress.Country'
    ],
    stepId: 1
  }
};
